import { render } from "./2.vue?vue&type=template&id=2832ae9e&scoped=true"
import script from "./2.vue?vue&type=script&lang=js"
export * from "./2.vue?vue&type=script&lang=js"

import "./2.vue?vue&type=style&index=0&id=2832ae9e&scoped=true&lang=css"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2832ae9e"]])

export default __exports__